import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as router from '@attain-apps/fe/web/main/lib/router'
import { PartialId } from '@attain-apps/string-builder'

import * as state from '../../../../../../state'
import * as common from '../../common'

@ngCore.Component({
  imports: [
    ds.layout.accordion.Component,
    ds.layout.widget.Component,
    ds.layout.page.child.header.Component,
    ds.layout.page.Component,
    common.modelCard.Component,
    ngCommon.NgFor,
  ],
  selector: 'atn-dms-dimension-page',
  standalone: true,
  styleUrls: ['./page.component.scss'],
  templateUrl: './page.component.html',
})
export class Page {
  /** @see {@link state.dms.dimensions.Collection} */
  private readonly _dimensionsEc = ngCore.inject(
    state.dms.dimensions.Collection,
  )

  /** @see {@link state.dms.entities.Collection} */
  private readonly _entitiesEc = ngCore.inject(state.dms.entities.Collection)

  /** @see {@link state.dms.snapshots.Collection} */
  private readonly _snapshotsEc = ngCore.inject(state.dms.snapshots.Collection)

  /** @see {@link state.me.Feature} */
  private readonly _meFeature = ngCore.inject(state.me.Feature)

  /** @see {@link router.Router} */
  private readonly _router = ngCore.inject(router.Router)

  /**
   * @see {@link PartialId }
   */
  public readonly partialIdSg = ngCore.computed(
    (dimension = this.dimensionSg()) =>
      dimension
        ? ents.core.dms.models.Id.Parts.from(dimension)?.partialId
        : undefined,
  )

  /**
   * @see {@link ents.core.dms.models.Model.isStandard }
   */
  public readonly isStandardDimensionSg = ngCore.computed(
    (dimension = this.dimensionSg()) =>
      !!dimension && ents.core.dms.models.Model.isStandard(dimension),
  )

  /** Name of the current dimension */
  public readonly dimensionNameSg = ngCore.computed(
    (dimension = this.dimensionSg()) => dimension?.name,
  )

  /** Id of the current dimension */
  public readonly dimensionIdSg = ngCore.computed(
    (dimension = this.dimensionSg()) => dimension?.id,
  )

  /** Entities of the current dimension */
  public readonly dimensionEntitiesSg = ngCore.computed(
    (dimension = this.dimensionSg()) => dimension?.entities ?? [],
  )

  /** Snapshots of the current dimension */
  public readonly dimensionSnapshotsSg = ngCore.computed(
    (dimension = this.dimensionSg()) => dimension?.snapshots ?? [],
  )

  /** Description of the current dimension */
  public readonly dimensionDescriptionSg = ngCore.computed(
    (dimension = this.dimensionSg()) => dimension?.description,
  )

  /**
   * Breadcrumbs displayed in page header
   */
  public readonly breadcrumbsSg = ngCore.computed(
    () =>
      [
        {
          name: 'Catalog',
          url: this._meFeature.contexts.selectors
            .getUrlForLink({
              goto: {
                navigationId: ents.extra.prebuilt.AppPageAlias.Catalog,
              },
            })
            .asSignal(),
        },
        { name: this.dimensionNameSg() ?? '' },
      ] satisfies readonly ds.layout.page.child.header.models.Breadcrumb[],
  )

  /** Signal representing the current dimension */
  public dimensionSg =
    this._dimensionsEc.plugins.currentEntityPlugin.feature.selectors.getEntity()
      .asSignal

  public entityClickedHandler(entityId: string): void {
    const source = 'AtnDimensionComponent.entityClickedHandler'
    this._entitiesEc.plugins.currentEntityPlugin.storage.actions.putInIdLookup
      .from(source)
      .dispatch({ value: entityId })

    const url = this._meFeature.contexts.selectors
      .getUrlForLink({
        goto: {
          navigationId: ents.extra.prebuilt.AppPageAlias.Entity,
        },
      })
      .asSignal()

    if (url) {
      this._router.actions.navigate.from(source).dispatch({ url })
    }
  }

  /**
   * Opens the snapshot page. WIP
   */
  // TODO: Think about mergin entityClickedHandler and snapshot click handler
  // into one.
  public snapshotClickedHandler(snapshotId: string): void {
    // TODO: Implement click handler once the snapshot page is created or entity
    // page is repurposed to show both snapshots and entities
    const source = 'AtnDimensionComponent.snapshotClickedHandler'
    this._snapshotsEc.plugins.currentEntityPlugin.storage.actions.putInIdLookup
      .from(source)
      .dispatch({ value: snapshotId })
    const url = this._meFeature.contexts.selectors
      .getUrlForLink({
        goto: {
          navigationId: ents.extra.prebuilt.AppPageAlias.Entity,
        },
      })
      .asSignal()
    if (url) {
      this._router.actions.navigate.from(source).dispatch({ url })
    }
  }
}
